module.exports = __webpack_public_path__ + "img/logo.ea76784f.png";